<template>
  <div>
    <p v-if="isLoading">Загрузка...</p>
    <b-table-simple v-else bordered="">
      <b-thead head-variant="light">
        <b-tr>
          <b-th>#</b-th>
          <b-th>Учетный месяц</b-th>
          <b-th>Учетный год</b-th>
          <b-th>Количество дней фактического пребывания</b-th>
          <b-th>Количество дней планируемого пребывания (только в план табеле)</b-th>
          <b-th>Дни отсутствия по уважительной причине</b-th>
          <b-th>Дни отсутствия по неуважительной причине</b-th>
          <b-th>Дни, в которых более 40 дней БП (без причины)</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(data, index) in childTimesheetInfoResponse" :key="index">
          <b-tr>
            <b-td>{{ index + 1 }}</b-td>
            <b-td>{{ data.accountingMonth }}</b-td>
            <b-td>{{ data.accountingYear }}</b-td>
            <b-td>{{ data.factPresenceDays }}</b-td>
            <b-td>{{ data.planPresenceDays }}</b-td>
            <b-td>{{ data.excusedAbsenceDays }}</b-td>
            <b-td>{{ data.unexcusedAbsenceDays }}</b-td>
            <b-td>{{ data.absenceRedLine }}</b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import {ChildTimesheetInfoResponse} from "@/types/childrenResponse";
import {getChildrenKindergartens, getChildrenTimesheet} from "@/services/childrenService";
import {useRoute} from "vue-router";

export default defineComponent({
  name: 'ChildrenTimesheetView',
  setup() {
    const childTimesheetInfoResponse = ref<ChildTimesheetInfoResponse[]>([]);
    const childId = ref<string>("");
    const isLoading = ref(false);

    const fetchData = async () => {
      isLoading.value = true;
      try {
        childTimesheetInfoResponse.value = await getChildrenTimesheet(childId.value);
      } catch (error) {
        console.error("Error fetching child short info list:", error);
      }
      isLoading.value = false;
    }

    onMounted(() => {
      const route = useRoute();
      childId.value = route.params.id as string;
      fetchData();
    });

    return {
      isLoading,
      childTimesheetInfoResponse,
    }
  }
})
</script>

<style scoped></style>